import React from 'react';
import cx from 'classnames';
import { StreamingVideoTreeNodeData } from '@mutiny-pkg/champaign-schemas/src/schemas/flexiblePages/flexiblePagesTreeNode';
import { transformToContainerQueries } from '../utils/transformBreakpointClasses';

export const Video = React.forwardRef<
  HTMLVideoElement,
  StreamingVideoTreeNodeData & { id: string; editorClassName?: string; isEditor?: boolean }
>(
  (
    {
      id,
      className,
      editorClassName,
      src,
      alt,
      poster,
      autoplay,
      controls,
      loop,
      muted,
      trackSrc,
      trackLabel,
      trackSrcLang,
      isEditor = false,
      ...props
    },
    ref,
  ) => {
    return (
      <video
        id={id}
        ref={ref}
        className={cx(transformToContainerQueries(className, { isEditor }), editorClassName)}
        src={src}
        poster={poster}
        autoPlay={autoplay}
        controls={controls}
        loop={loop}
        muted={muted}
        aria-label={alt}
        {...props}
      >
        <track
          kind="captions"
          src={trackSrc || ''}
          srcLang={trackSrcLang || 'en'}
          label={trackLabel || 'No captions available'}
        />
      </video>
    );
  },
);

Video.displayName = 'Video';
